jQuery(document).ready(function($) {

    $( ".bloc_actualites" ).each(function( index ) {

        var parent = $(this).find(".liste_articles")
        var cibleActus = parent.find(".tile")

        gsap.from( cibleActus, {
            y : +200,
            duration: 1,
            stagger: .2,
            ease: "power2.out",
            scrollTrigger: {
                trigger: parent,
                markers: false,
                start: "top 100%",
                end: "top 50%",
                scrub: 1,
            }

        })


    })

});